import TreeItem from "@material-ui/lab/TreeItem";
import { ICardElementWithChildren } from "backend/model/model";
import { getTranslatedAttribute } from "qpr-base//tplutils/utils";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import { makeThemedStyles } from "qpr-base/viewcomponents/utils";
import React from "react";

const useItemStyles = makeThemedStyles("ElementTreeViewItem", (theme) => ({
  rootLabel: {
    fontWeight: "bold",
    color: "#555",
    marginLeft: "16px",
    "& .Mui-selected:focus .MuiTreeItem.content .MuiTreeItem-label": {
      color: "red",
    },
  },
  nestedLabel: {
    marginLeft: "18px",
    padding: "2px",
  },
  rootGroup: {
    marginInlineStart: 0,
  },
  nestedGroup: {
    marginInlineStart: 0,
  },
  selected: {
    "& .MuiTreeItem-content > .MuiTreeItem-label": {
      color: "#296Ba2",
    },
  },
  disabled: {
    pointerEvents: "none",
    opacity: 0.5,
  },
  root: {
    "& .MuiTreeItem-iconContainer": {
      width: "0px",
      marginLeft: "0px",
    },
    "& li > .MuiTreeItem-content > .MuiTreeItem-label": {
      color: "#555",
      marginTop: "0px",
    },
    "& li.Mui-selected > .MuiTreeItem-content > .MuiTreeItem-label": {
      color: "#296Ba2",
    },
    "& .MuiTreeItem-content > .MuiTreeItem-label": {
      marginTop: "10px",
      fontSize: "13px",
      fontWeight: "bold",
    },
  },
  nested: {
    "& li > .MuiTreeItem-content > .MuiTreeItem-label": {
      paddingInlineStart: "16px",
      fontWeight: "normal",
    },
  },
  iconContainer: {},
}));

const ElementTreeViewItem = (
  props: React.PropsWithChildren<{
    item: ICardElementWithChildren;
    rootLevel: boolean;
  }>
) => {
  const { item } = props;
  const ctx = useAppContext();
  const styles = useItemStyles();
  if (!item?.name) return <></>; // if !item?.name -> user does not have rights to this element
const isDisabled =
  item.accesslevel === "-1" &&
  (
    item?.children?.every(
      (child) =>
        child.accesslevel === "-1" &&
        child.children?.every(
          (grandchild) =>
            grandchild.accesslevel === "-1" &&
            grandchild.children?.every(
              (greatGrandchild) => greatGrandchild.accesslevel === "-1"
            )
        )
    ) ||
    item.children === undefined ||
    item.children.length === 0
  );
  return (
    <TreeItem
      nodeId={item.id}
      label={getTranslatedAttribute(item, "Name", ctx.language)}
      classes={{
        root: props.rootLevel ? styles.root : styles.nested,
        group: props.rootLevel ? styles.rootGroup : styles.nestedGroup,
        iconContainer: styles.iconContainer,
        label: props.rootLevel ? styles.rootLabel : styles.nestedLabel,
        selected: styles.selected,
      }}
      className={isDisabled ? styles.disabled : ""}
    >
      {item.children
        ? item.children
            .sort((a, b) => {
              if (!a?.accesslevel || !b?.accesslevel) return 0;
              return Number(b?.accesslevel) - Number(a?.accesslevel);
            })
            .filter((child) => child?.name)
            .map((child) => {
              return (
                <ElementTreeViewItem
                  key={child.id}
                  item={child}
                  rootLevel={false}
                />
              );
            })
        : null}
    </TreeItem>
  );
};

export default ElementTreeViewItem;
